<template>
    <div class="Product">
      <div id="carouselOne" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselOne" data-slide-to="0" class="active"></li>
          <li data-target="#carouselOne" data-slide-to="1"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="d-block carouse-img-one" src="../assets/ShopSelfPrinting/banner1.png" alt="自助打印解决方案专家">
            <div class="content-detail">
              <h1 class="left">手机自助打印</h1>
              <p class="right" style="margin-top:50px">节省人力成本，助力引流增收</p>
              <p class="right ">用自助打印提升您的经营效率</p>
              <el-button class="download-btn" type="primary" icon="el-icon-download"
                @click="goDownloadFn()">立即下载</el-button>
            </div>
          </div>
          <div class="carousel-item">
            <img class="d-block carouse-img-one" src="../assets/ShopSelfPrinting/banner2.png" alt="电脑自助打印专区">
            <el-button class="download-btn" type="primary" icon="el-icon-download" @click="goDownloadFn()"
              style="position: absolute;left: 58%;bottom: 8%;">立即下载</el-button>
          </div>
  
        </div>
      </div>
  
  
      <div class="tab-content">
        <div class="container tab-pane fade in active" id="weChat">
          <div class="row content-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1>新一代打印物联网云打印</h1>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="card-deck">
                <div class="card service">
                  <img class="card-img-top service-img" src="../assets/ShopSelfPrinting/service_1.png" alt="Card image cap">
                  <div class="card-body">
                    <h4 class="card-title">100000+</h4>
                    <p class="card-text">自助打印网点</p>
                  </div>
                </div>
                <div class="card service">
                  <img class="card-img-top service-img" src="../assets/ShopSelfPrinting/service_2.png" alt="Card image cap">
                  <div class="card-body">
                    <h4 class="card-title">3亿+</h4>
                    <p class="card-text">服务人次/年</p>
                  </div>
                </div>
                <div class="card service">
                  <img class="card-img-top service-img" src="../assets/ShopSelfPrinting/service_3.png" alt="Card image cap">
                  <div class="card-body">
                    <h4 class="card-title">6.0亿+</h4>
                    <p class="card-text">订单</p>
                  </div>
                </div>
                <div class="card service">
                  <img class="card-img-top service-img" src="../assets/ShopSelfPrinting/service_4.png" alt="Card image cap">
                  <div class="card-body">
                    <h4 class="card-title">800W小时</h4>
                    <p class="card-text">帮商户节省</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  
      <div class="tab-content" style="background-color: #F1F9FF;">
        <div class="container tab-pane fade in active" id="weChat">
          <div class="row content-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1>应用场景解决方案</h1>
            </div>
            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
              <div class="app-card">
                <h5 class="tit">手动数纸张、手动收钱、套单漏单、废止问题？</h5>
                <div class="label">
                  <span class="label-l">省力</span>
                  <span class="label-r">一站式自助打印文件自动识别计费</span>
                </div>
                <div class="tips">软件自动计算纸张数量，先支付后打印,防止纸张损耗，并可自动识别WORD、CAD或图片等多种文件格式并单独计价。。</div>
              </div>
              <div class="app-card">
                <h5 class="tit">打印时间效率低下，影响营收？</h5>
                <div class="label">
                  <span class="label-l">省人</span>
                  <span class="label-r">多方式一键上传文件，提高打印效率</span>
                </div>
              </div>
              <div class="app-card">
                <h5 class="tit">担心软件不易用，每天记账，花时花力？</h5>
                <div class="label">
                  <span class="label-l">省心</span>
                  <span class="label-r">财务清晰管理，专属1V1客服服务解答</span>
                </div>
              </div>
            </div>
            <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
              <img class="app-img" src="../assets/ShopSelfPrinting/app_1.png" alt="Card image cap">
            </div>
          </div>
        </div>
      </div>
  
      <div class="tab-content">
        <div class="container tab-pane fade in active" id="weChat">
          <div class="row content-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1>特色功能</h1>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="card-deck">
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_1.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">手机自助打印</h5>
                    <p class="card-text">QQ/微信扫码打印，稳定、快速，可多人扫码打印，提高效率，增加营收</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_2.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">电脑自助打印</h5>
                    <p class="card-text">一站式自助打印：扫码传文件>打印>收款>出纸，傻瓜式打印，高效易上手</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_3.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">财务管理系统</h5>
                    <p class="card-text">费率自由设定，资金明细清晰，自动记录分析每笔订单，支持微信、支付宝、现金支付</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="card-deck">
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_4.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">会员卡系统</h5>
                    <p class="card-text">店铺自定义充值套餐，助力锁定客源，快速回笼资金</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_5.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">促销活动助力引流增收</h5>
                    <p class="card-text">店主可自主设置充值赠送活动补贴，学生到店打印有机会享受免单打印</p>
                  </div>
                </div>
                <div class="card card-kind">
                  <img class="card-img-top ability-img" src="../assets/ShopSelfPrinting/ability_6.png" alt="Card image cap">
                  <div class="card-body">
                    <h5 class="card-title">一键去黑底</h5>
                    <p class="card-text">作业打印、照片打印，一键去黑底，秒变清晰！更多特色功能，等你体验……</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
  
      <div class="tab-content" style="background-color: #F1F9FF;">
        <div class="container tab-pane fade in active">
          <div class="row content-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1 style="margin-bottom: 40px;">案例</h1>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <!-- 轮播图开始 -->
              <div id="carouselTwo" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li data-target="#carouselTwo" data-slide-to="0" class="active"></li>
                  <!-- <li data-target="#carouselTwo" data-slide-to="1"></li>
                  <li data-target="#carouselTwo" data-slide-to="2"></li> -->
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="case-img" src="../assets/ShopSelfPrinting/case_1.png"
                      alt="印点点自助打印系统实现店铺内人力资源的极大优化，还实现了店内财务管理的规范化、数据化，为我接下来的连锁打印点带来了极大的管理便利。">
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
  
      <div class="tab-content" style="background-color: #fff;">
        <div class="container tab-pane fade in active">
          <div class="row content-title">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h1>合作伙伴</h1>
            </div>
          </div>
          <img class="cooperate-img" src="../assets/ShopSelfPrinting/cooperate.png" alt="First slide">
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
      }
    },
    created() {
      window.scrollTo(0, 0);
    },
    mounted() {
      setTimeout(() => {
        $("#carouselOne").carousel({
          interval: 4000
        });
        $("#carouselTwo").carousel({
          interval: 4000
        });
      }, 200);
    },
    methods: {
      goDownloadFn() {
        this.$router.push("/DownLoad")
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  /* Chrome, Safari, Opera */
  .content {
    width: 100%;
    position: relative;
    background: no-repeat center center;
    background-size: cover;
    padding-top: 61px;
    height: 540px;
    overflow: hidden;
  }
  
  .content-detail {
    position: absolute;
    top: 8rem;
    left: 15vw;
  
    h1 {
      font-size: 2.8rem;
      line-height: 2rem;
      color: #fff;
    }
  
    p {
      font-size: 1.75rem;
      color: #fff;
    }
  }
  
  .carouse-img-one {
    width: 100%;
  }
  
  .active {
    opacity: 1 !important;
  }
  
  .content-title {
    text-align: center;
    padding: 60px 0 70px;
  
    h1 {
      color: #18182a;
      font-weight: normal;
      font-stretch: normal;
      font-size: 40px;
    }
  }
  
  .card-kind,
  .service {
    padding: 20px 0;
    border: 0 !important;
    transition: all 0.2s;
  }
  
  .service {
    .card-title {
      font-weight: 600;
    }
  
    &:hover {
      transform: scale(1.1, 1.1);
    }
  }
  
  
  
  .card-kind:hover {
    img {
      transform: rotate(360deg);
      transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
    }
  
    h5 {
      color: #30bbfc;
      transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
  
  .service-img,
  .ability-img {
    width: 100px;
    height: 100px;
    margin: 30px auto 0;
  }
  
  .margin {
    margin-top: 100px;
  }
  
  .app-card {
    text-align: left;
    margin-bottom: 38px;
    box-sizing: border-box;
    border-bottom: 2px solid #F1F9FF;
  
    .tit {
      margin-bottom: 20px;
      font-weight: 700;
    }
  
    .label {
      margin-bottom: 16px;
  
      .label-l {
        font-weight: 700;
      }
  
      .label-r {
        color: #666666;
        margin-left: 13px;
      }
    }
  
    .tips {
      color: #666666;
      margin-bottom: 20px;
    }
  
    &:hover {
      border-bottom: 2px solid #30bbfc;
  
      .tit {
        color: #30bbfc;
      }
    }
  
  }
  
  .app-img,
  .cooperate-img {
    width: 100%;
    height: auto;
  }
  
  .case-img {
    width: 100%;
    height: auto;
    margin-bottom: 40px;
  }
  
  
  
  .download-btn {
    animation: shake 2.5s ease-in-out infinite;
  }
  
  .download-btn:hover {
    animation: none;
    /* 停止动画效果 */
  }
  
  @keyframes shake {
  
    0%,
    91%,
    100% {
      transform: translateX(0);
    }
  
    92%,
    98% {
      transform: translateX(-5px);
    }
  
    95% {
      transform: translateX(5px);
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/ShopSelfPrintingPc.vue